/*
 * @Author: 陈浩彬
 * @Date: 2021-09-07 15:15:36
 * @LastEditTime: 2021-09-13 16:18:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \logistics-fe-otp\src\modules\otp\api\algorithmParameters.js
 */
import request from '@/utils/http';

// 主页列表数据
export const getSearchList = (data) => {
    return request({
        url: `/api-tms/baseLimitAreass`,
        method: 'post',
        data
    });
};

// 删除
export const deleteByIds = (params) => {
    return request({
        url: `/api-tms/baseLimitAreas`,
        method: 'delete',
        data: params
    });
};

// 新增
export const saveDate = (params) => {
    return request({
        url: `/api-tms/baseLimitAreas`,
        method: 'post',
        data: params
    });
};
// 编辑
export const editDate = (params) => {
    return request({
        url: `/api-tms/baseLimitAreas/${params.id}`,
        method: 'put',
        data: params
    });
};
// 获取车型字典值
export const getCarListApi = (params) => {
    return request({
        url: `/api-tms/algorithm/equipment/dict/query`,
        method: 'post',
        data: params
    });
};
